import v1 from 'uuid';
/**
 * Builds a service to access FeatureFlags
 */

let subscribers = {};
let currentScreenSubscriptions = {};

export function getSubscribers(eventName) {
  return Object.values(subscribers[eventName] || {});
}

export function publishEvent(eventName, payload, metadata = {}) {
  if (!subscribers[eventName]) return;
    
  for (const key in subscribers[eventName]) {
    subscribers[eventName][key](payload, metadata);
  }
}

export function subscribeToEvent(eventName, callback, metadata = null) {
  if (!subscribers[eventName]) {
    subscribers[eventName] = {};
  }

  const subcriptionId = v1 ();
  subscribers[eventName][subcriptionId] = callback;

  if (metadata) {
    currentScreenSubscriptions[metadata] = currentScreenSubscriptions[metadata] || [];
    currentScreenSubscriptions[metadata].push({ eventName, subcriptionId });
  }

  // unsubscribe event
  return () => {
    delete subscribers[eventName][subcriptionId];
  };
}

export function clearSubscriptionForScreen(screenId) {
  if(currentScreenSubscriptions[screenId]?.length) {
    currentScreenSubscriptions[screenId].forEach(({ eventName, subcriptionId }) => {
      delete subscribers[eventName][subcriptionId];
    });
  }

  delete currentScreenSubscriptions[screenId];
}